module.exports = __webpack_public_path__ + "img/02.95c24b6f.jpg";